/*
    configurationObject
    path: defines the api to request
    method: defines the request method, GET by default, POST and PUT methods add necessary headers by default
    headers: object to add extra headers, for example multipart/formdata
    params: object that adds query string to path
    body: add formData/files to post request
    overwritePath: if true takes the path from config and set into result object
*/
import { getToken, addExtraHeadersIfIsExplorerorEdge } from '../helpers';

export default (configurationObject) => {
    const config = getConfiguration(configurationObject);
    let { path, method, headers, body } = config;
    return fetch(path, {
            method,
            headers,
            body
        })
        .then(res => res.json())
        .then(response => {
           return response;
        })
        .catch(function(error) {
           return error;
        });
}


const getConfiguration = (configurationObject) => {
    const defaultConfiguration = {
        path: '/api/',
        method: 'GET',
        params: {},
        body: {},
        headers: {
            Authorization: 'Bearer ' + getToken(),
            ...addExtraHeadersIfIsExplorerorEdge()
        },
        overwritePath: false,
    }
    let headers = {
        ...configurationObject.headers,
        ...defaultConfiguration.headers,
    };
    let hasBody = Boolean(configurationObject.body);
    let isFormData = hasBody && configurationObject.body instanceof FormData;
    if (configurationObject.method) {
        let method = configurationObject.method.toUpperCase();
        if (method === 'POST' || method === 'PUT') {
            if(!isFormData) {
                headers = {
                    ...headers,
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                }
            } else {
                delete headers['Content-Type'];
            }
        }
    }
    let path = '';
    if (!configurationObject.overwritePath) {
        path = `${defaultConfiguration.path}${configurationObject.path}${getQueryString(configurationObject.params ? configurationObject.params : {})}`;
    } else {// if true takes path value from configurationObject and instead of concatenate it, overwrite the value. For example to consult extern API
        path = `${configurationObject.path}${getQueryString(configurationObject.params ? configurationObject.params : {})}`;
    }

    let body = null;
    if(hasBody) {
        if(!isFormData) {
            body = JSON.stringify(configurationObject.body);
        } else {
            body = configurationObject.body;
        }
    }

    let newObject = {
        path,
        method: configurationObject.method ? configurationObject.method : defaultConfiguration.method,
        body,
        headers
    };

    return newObject;
}


const getQueryString = (obj) => {
    var parts = [];
    for (var i in obj) {
        if (obj.hasOwnProperty(i)) {
            parts.push(encodeURIComponent(i) + "=" + encodeURIComponent(obj[i]));
        }
    }
    return parts.length ? `?${parts.join('&')}` : '';
}

// examples
// const postRequestWithExtraHeaders = { //post with extra params
//     path: 'mipath',
//     method:'POST',
//     params: { param1:1, param2:2 },
//     body: { bodyParam:1, bodyParam2: 2 },
//     headers: {
//         'SpecialHeader': 'SpecialHeader',
//         'AnotherSpecialHeader': 'AnotherSpecialHeader'
//     }
// }
// const postRequest = { //set by default headers = {Accept: "application/json",Content-Type: "application/json"}
//     path: 'mipath',
//     method:'POST',
//     body: { bodyParam:1, bodyParam2: 2 },
// }

// const getRequest = { //GET method by default
//     path: 'mipath',
// }

// const getRequestWithParams = { //if doesnt have method then GET method by default 
//     path: 'mipath',
//     params: { param1:1, param2:2 },
// }

// const formData = {}; //your formData

// const uploadFileRequest = { 
//     path: 'mipath',
//     headers: {
//         'Content-Type': 'multipart/form-data',
//     },
//     method: 'POST',
//     body: formData
// }

// const formDataRequest = { //set by default headers = {Accept: "application/json",Content-Type: "application/json"}
//     path: 'mipath',
//     method: 'POST',
//     body: formData
// }

// let postWithExtraHeaders = getConfiguration(postRequestWithExtraHeaders);
// console.log(postWithExtraHeaders)
// let simplePost = getConfiguration(postRequest);
// console.log(simplePost)
// let simpleGet = getConfiguration(getRequest);
// console.log(simpleGet)
// let getWithParams = getConfiguration(getRequestWithParams);
// console.log(getWithParams)
// let uploadFile = getConfiguration(uploadFileRequest);
// console.log(uploadFile)
// let formDataConfig = getConfiguration(formDataRequest);
// console.log(formDataConfig)